import { createFileRoute } from "@tanstack/react-router";

import { MessagesPage } from "../../../../areas/admin/messages/MessagesPage";
import { validateAdminMessagesSearch } from "../../../../areas/admin/sections/search";

/** Message log (FE-14 FR-FE14-24): channel, status and template filters in the URL. */
export const Route = createFileRoute("/app/_seller/admin/messages")({
  validateSearch: validateAdminMessagesSearch,
  component: AdminMessages,
});

function AdminMessages() {
  const search = Route.useSearch();
  return <MessagesPage search={search} />;
}
